(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-minimal"] && !Shopify.designMode) return;
  try {
    (() => {
    const mediaElements = document.querySelectorAll('.product-card-minimal__media');

    mediaElements.forEach((media) => {
      if (media.dataset.scrubBound == 'true') return;
      media.dataset.scrubBound = 'true';

      const images = media.querySelectorAll('.product-card-minimal__image[data-image-index]');
      if (images.length < 2) return;

      let activeIndex = 0;

      function setActiveImage(nextIndex) {
        const safeIndex = Math.max(0, Math.min(nextIndex, images.length - 1));
        if (safeIndex === activeIndex) return;

        images[activeIndex].classList.remove('is-active');
        images[safeIndex].classList.add('is-active');
        activeIndex = safeIndex;
      }

      function scrubToPointerPosition(event) {
        const rect = media.getBoundingClientRect();
        if (rect.width <= 0) return;

        const xPosition = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
        const ratio = xPosition / rect.width;
        const nextIndex = Math.min(images.length - 1, Math.floor(ratio * images.length));
        setActiveImage(nextIndex);
      }

      function resetToFirstImage() {
        setActiveImage(0);
      }

      media.addEventListener('mousemove', scrubToPointerPosition);
      media.addEventListener('mouseleave', resetToFirstImage);
      media.addEventListener('blur', resetToFirstImage, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
